(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("bfVQq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bd5c81639d1eca2$export$2e2bcd8739ae039; });
const $5bd5c81639d1eca2$var$createSnowplowV2TrackerEcommerceEventsHandlers = (input)=>{
    const { appId: appId, retailId: retailId, environment: environment } = input;
    return {
        trackTransaction (input) {
            window.tracker(`addTrans`, {
                orderId: input.id,
                affiliation: input.affiliateId || (retailId !== null && retailId !== void 0 ? retailId : appId),
                total: input.total,
                tax: input.tax,
                shipping: input.shipping,
                city: input.city,
                state: input.state,
                country: input.country,
                currency: input.currency,
                context: [
                    {
                        schema: "iglu:com.mediajel.events/enhanced_transaction/jsonschema/1-0-1",
                        data: {
                            cart: environment,
                            transaction_ids: input.alternativeTransactionIds,
                            discount: input.discount,
                            coupon_code: input.couponCode
                        }
                    }
                ]
            });
            input.items.forEach((item)=>{
                window.tracker(`addItem`, {
                    orderId: item.orderId,
                    sku: item.sku,
                    name: item.name,
                    category: item.category,
                    price: item.unitPrice,
                    quantity: item.quantity,
                    currency: item.currency
                });
            });
            window.tracker(`trackTrans`);
        },
        trackAddToCart (input) {
            window.tracker("trackAddToCart", {
                sku: input.sku,
                name: input.name,
                category: input.category,
                unitPrice: input.unitPrice,
                quantity: input.quantity,
                currency: input.currency
            });
        },
        trackRemoveFromCart (input) {
            window.tracker("trackRemoveFromCart", {
                sku: input.sku,
                name: input.name,
                category: input.category,
                unitPrice: input.unitPrice,
                quantity: input.quantity,
                currency: input.currency
            });
        }
    };
};
var $5bd5c81639d1eca2$export$2e2bcd8739ae039 = $5bd5c81639d1eca2$var$createSnowplowV2TrackerEcommerceEventsHandlers;

});

})();
//# sourceMappingURL=ecommerce.66b8c4d7.js.map
